import { ReactNode } from 'react';
import clsx from 'clsx';

interface SectionWrapperProps {
  children: ReactNode;
  colored?: boolean;
  isFirst?: boolean;
}

const SectionWrapper: React.FC<SectionWrapperProps> = ({ children, colored = false, isFirst = false }) => {
  return (
    <div
      className={clsx(' text-center ', {
        'py-10 lg:py-16': !isFirst,
        'pb-10 lg:pb-16': isFirst,
        'bg-base-200': colored,
      })}
    >
      <div className="page-layout">{children}</div>
    </div>
  );
};

export default SectionWrapper;
